import { Badge } from 'antd';
import React from 'react';
import { Props } from './index';
import { TRANSFERS_CHANGED_EVENT } from '../../modules/transfers/helpers';
import { RoleEnum, ToolTransfersClient } from '../../utils/api';

interface State {
    noOfPendingTransfers: number;
}

/**
 * Shipped transfers waiting for this site manager to receive them. The endpoint already
 * scopes the count to his own destination warehouses and returns 0 for everyone else.
 */
class TransferBadge extends React.Component<Props, State> {
    private intervalId: NodeJS.Timeout | null = null;

    public constructor(props: Props) {
        super(props);

        this.state = {
            noOfPendingTransfers: 0,
        };
    }

    componentDidMount = async () => {
        await this.getNumberOfPendingTransfers();

        this.intervalId = setInterval(async () => {
            await this.getNumberOfPendingTransfers();
        }, 60000);

        window.addEventListener(TRANSFERS_CHANGED_EVENT, this.handleTransfersChanged);
    };

    private handleTransfersChanged = () => {
        void this.getNumberOfPendingTransfers();
    };

    componentWillUnmount() {
        window.removeEventListener(TRANSFERS_CHANGED_EVENT, this.handleTransfersChanged);

        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    async getNumberOfPendingTransfers() {
        const { userRole } = this.props;

        if (userRole !== RoleEnum.SiteManager) return;

        const count = await new ToolTransfersClient().getPendingCount();

        this.setState({ noOfPendingTransfers: count });
    }

    public render(): React.ReactElement {
        const { userRole } = this.props;
        const { noOfPendingTransfers } = this.state;

        return userRole === RoleEnum.SiteManager ? (
            <Badge count={noOfPendingTransfers} size="small" style={{ marginLeft: 8 }} />
        ) : (
            <></>
        );
    }
}

export default TransferBadge;
